export const HUBSPOT_FORM_ID_ASK_ADVISOR_NEWLAND =
  "05274721-8120-4df0-83e3-b4aca5d5b9e8";
